import { AxiosResponse } from "axios";
import { CreditsCardCompanies, GetRejectCardsResponse, GetRejectedDebitsListResponse, RejectedCreditsFilters, RejectedDebitsFilters } from "../../../interfaces/services/rejected-credits";
import { getError, getUserInfo } from "../../../utils";
import CustomHttpClient from "../../customHttpClient";
import { SelectOption } from "../../../interfaces";

const customHttpClient = CustomHttpClient({ baseUrl: 'productores' });
const customHttpClientMaestros = CustomHttpClient({ baseUrl: 'maestros' });

const AutomaticDebitsRejectedService = {
    async getRejectedDebitsList(filters: RejectedCreditsFilters): Promise<GetRejectCardsResponse> {
        const url = 'rechazosBancarios';
        const params = {
          ...getUserInfo(),
          anio: filters.year,
          mes: filters.month,
        };
    
        try {
          const response = await customHttpClient.get(url, { params });
    
          return response.data;
        } catch (error) {
          throw new Error(getError(error));
        }
    },

    async getRejectedCreditsList(filters: RejectedCreditsFilters): Promise<GetRejectCardsResponse> {
      const url = 'rechazosTarjeta';
      const params = {
        ...getUserInfo(),
        anio: filters.year,
        mes: filters.month,
        codigoTarjeta: filters.entity
      };
  
      try {
        const response = await customHttpClient.get(url, { params });
  
        return response.data;
      } catch (error) {
        throw new Error(getError(error));
      }
  },

    async getRejectedDetailsList(filters: RejectedDebitsFilters, numeroPreliquidacion:string): Promise<GetRejectedDebitsListResponse> {
      const url = 'detalleRechazos';
      const params = {
        ...getUserInfo(),
        numeroPreliquidacion,
        anio: filters.year,
        mes: filters.month
      };
  
      try {
        const response = await customHttpClient.get(url, { params });
  
        return response.data;
      } catch (error) {
        throw new Error(getError(error));
      }
  },

  async getCreditCardList(): Promise<AxiosResponse<Array<SelectOption>>> {
    const url = 'listaTarjetasDeCredito';
  
      try {
        const response = await customHttpClientMaestros.get(url);
  
        if (response.status === 200) {
          
          response.data = response.data.empresasTarjetaDeCredito.map((item: CreditsCardCompanies) => {
            return {
              value: item.idEmpresa,
              label: item.empresa,
            };
          });
        }

        return response;
      } catch (error) {
        throw new Error(getError(error));
      }
  }
}

export default AutomaticDebitsRejectedService